import { Collection } from "./collection.enum";

export enum Navigation {
    Races = Collection.Races,
    RaceDetail = Collection.Races + '/view',
    Events = Collection.Events,
    EventDetail = Collection.Events + '/view',
    Entries = Collection.Entries,
    EntryDetail = Collection.Entries + '/view',
}